import React, { useEffect, useRef, useState } from 'react';
import '../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';
import { fetchFusionInwardlist } from '../../Store/PHPSlice/Fusioning/fusioningApi';
import { selectFusionInwdata } from '../Selectors/TrackSelector/TrackSelector';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import SOMatOutViewReturn from '../Sale/View/SOMatOutViewReturn';


const FusionInwView2 = () => {
    const { Id } = useParams();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: '',
        empNm: '',
        ordType: '',
        soId: '',
        sono: '',
        totMtr: '',
        challanId: '',
        firmId: '',
        reMemo: ''
    });
    const [soMaterial, setSoMaterial] = useState([]);
    const dispatch = useDispatch();
    const fusionInwlist = useSelector(selectFusionInwdata);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        dispatch(fetchFusionInwardlist(Id));
        fetchMaterialProductionList(Id);
    }, [Id, dispatch]);

    useEffect(() => {
        if (fusionInwlist?.returnData) {
            const item = fusionInwlist.returnData;
            setFormData(prev => ({
                ...prev,
                id: item?.ID,
                dt: item?.dt,
                numMemo: item?.numMemo,
                sono: item?.sono,
                empNm: item?.empNm,
                itemId: item?.itemId,
                itemNm: item?.itemNm,
                finwMemo: item?.finwMemo,
                fmemo: item?.fmemo,
                fuId: item?.fuId,
                totqty: item?.totqty,
                reqty: item?.reqty,
                mcloth: item?.mcloth,
                mclothNm: item?.mclothNm,
                m1cloth: item?.m1cloth,
                m1clothNm: item?.m1clothNm,
                m2cloth: item?.m2cloth,
                m2clothNm: item?.m2clothNm,
                m3cloth: item?.m3cloth,
                m3clothNm: item?.m3clothNm,
                soId: item?.soId,
                sts: item?.sts,
                totInwqty: item?.reqty,
                firmId: item?.firmId || ''
            }));
        }
    }, [fusionInwlist]);


    const fetchMaterialProductionList = async (id) => {
        const departNm = "FUSIONING";
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialProduction_Returndata_departNm_prodInwid&departNm=${departNm}&prod_inw_id=${id}`)
            // console.log(res.data);
            setSoMaterial(res.data?.data || []);
        } catch (error) {
            console.error('error', error);
        }
    };

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };

    const qtyArr = fusionInwlist?.info.map(i => i.qty);
    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1% 0%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Fusion Inward Info - ({formData.finwMemo})</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Employee</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>Date</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.dt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Fusion Inw. Memo</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.finwMemo}</td>
                                    {/* <td style={{ width: '200px' }}>Cutting Return No.</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }}>{formData.ctMemo}</td> */}
                                </tr>


                                <tr>
                                    <td style={{ width: '200px' }}>Item</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.itemNm}</td>
                                    <td style={{ width: '200px' }}>Main Cloth</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.mclothNm}</td>
                                </tr>

                                <tr>
                                    <td>M1 Cloth</td>

                                    <td>{formData.m1clothNm || '-'}</td>
                                    <td>M2 Cloth</td>

                                    <td>{formData.m2clothNm || '-'}</td>
                                </tr>
                                <tr>
                                    <td>M3 Cloth</td>

                                    <td>{formData.m3clothNm || '-'}</td>

                                    <td>Total Inward Qty.</td>

                                    <td>{formData.totInwqty}</td>
                                </tr>


                            </tbody>


                        </table>
                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow className='tbl-row'>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Return Qty.</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(fusionInwlist?.info) && fusionInwlist.info.length > 0 ? (
                                        fusionInwlist?.info?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.qty}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} align='center'>No data available</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {
                            soMaterial.length > 0 &&
                            <div style={{ marginLeft: '5%' }}>
                                <h3>Material Details</h3>
                                <SOMatOutViewReturn array={soMaterial} qtyArr={qtyArr} />
                            </div>
                        }

                    </div>

                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default FusionInwView2;
